<template>
  <Navbar :url="imgurl" />
  <div class="create">
    <form>
      <label>Title:</label>
      <input type="text" v-model="title" required>
      <label>Content:</label>
      <textarea v-model="body" required></textarea>
      <label>Tags (hit enter to add a tag):</label>
      <input
        @keypress.enter.prevent="handleKeydown"
        type="text"
        v-model="tag">
      <div v-for="tag in tags" :key="tag" class="pill"># {{ tag }}</div>
      <button @click.prevent="handleSubmit" :class="{'disabled': (title=== '' || body=== '')}">Add Post</button>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import getUser from '../composables/getUser'
import { projectFirestore, timestamp } from '../firebase/config'
import Navbar from '../components/Navbar'

export default {
  components: {
    Navbar
  },
  setup() {
    const title = ref('');
    const body = ref('');
    const tag = ref('');
    const tags = ref([]);
    const router = useRouter();
    const { user, imgurl } = getUser();
    const handleKeydown = () => {
      if(!tags.value.includes(tag.value)) {
        tag.value = tag.value.replace(/\s/g, '');
        tags.value.push(tag.value);
      }
      tag.value = '';
    }
    const handleSubmit = async () => {
      const post = {
        title: title.value,
        body: body.value,
        tags: tags.value,
        userId: user.value.uid,
        userName: user.value.displayName,
        createdAt: timestamp() //排序用
      };
      const res = await projectFirestore.collection('posts').add(post);
      // 非同步，連接store的collection(post)，並在其中增加post，等到增加成功才會繼續往下
      router.push({ name: 'Blog'});
    }
    return { title, body, tag, tags, handleKeydown, handleSubmit, imgurl}
  }
}
</script>

<style>
  form {
    max-width: 600px;
    margin: 0 auto;
    text-align: left;
  }
  input, textarea {
    display: block;
    margin: 10px 0;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    border: 1px solid #eee;
  }
  textarea {
    height: 200px;
  }
  label {
    display: inline-block;
    margin-top: 30px;
    position: relative;
    font-size: 20px;
    color: white;
    margin-bottom: 10px;
  }
  label::before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background: #ff8800;
    position: absolute;
    z-index: -1;
    padding-right: 40px;
    left: -30px;
    transform: rotateZ(-1.5deg);
  }
  button {
    display: block;
    margin-top: 30px;
    background: #ff8800;
    color: white;
    border: none;
    padding: 8px 16px;
    font-size: 18px
  }
  button:hover {
    background: #c26802;
  }
  button.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  .pill {
    display: inline-block;
    margin: 10px 10px 0 0;
    color: #444;
    background: #ddd;
    padding: 8px;
    border-radius: 20px;
    font-size: 14px;
  } 
</style>